<template>
  <vs-row>
    <vs-col vs-w="12">
      <vs-row  vs-align="center" vs-justify="center">
        <vs-col vs-w="2" class="text-end">
          <vs-button class="large-icon" size="large" color="primary" :type="mode === 'bar'? 'filled':'flat'" icon="bar_chart" @click="mode='bar'"></vs-button>
        </vs-col>
        <vs-col vs-w="2">
          <vs-button class="large-icon" size="large" color="primary" :type="mode === 'radar'? 'filled':'flat'" icon="fingerprint" @click="mode='radar'"></vs-button>
        </vs-col>
      </vs-row>
      <vs-row class="mt-8">
        <vs-col vs-w="12">
          <CheckupResultsRadarchart v-if="mode === 'radar'" :values="values" :show-labels="true" :show-animation="true"/>
          <CheckupResultsBarchart v-if="mode=== 'bar'" :values="values" :show-labels="true" :show-animation="true"/>
        </vs-col>
      </vs-row>
    </vs-col>
  </vs-row>
</template>

<script>
import CheckupResultsRadarchart from '@/views/app/view_member/charts/checkup-results-radarchart';
import CheckupResultsBarchart from '@/views/app/view_member/charts/checkup-results-barchart';

export default {
  name: 'checkup-results-charts',
  components: {
    CheckupResultsBarchart,
    CheckupResultsRadarchart
  },
  props: {
    values: Object
  },
  data () {
    return {
      mode: 'bar'
    };
  }
};
</script>

<style>
.vs-button.large.large-icon .vs-button--icon {
  font-size: 2.5rem;
}
</style>
